import axios from 'axios';

export const http = axios.create({
  baseURL: '/api',
  timeout: 60_000,
  withCredentials: true,
});

http.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('sqlops_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (r) => r,
  (error) => {
    const url: string = error.config?.url ?? '';
    const isAuthCall = url.includes('/auth/');
    if (error.response?.status === 401 && !isAuthCall) {
      sessionStorage.removeItem('sqlops_token');
      sessionStorage.removeItem('sqlops_user');
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);
